// Xóa item theo nhiều id
export const deleteItemsByIds = (treeArray, idsToDelete) => {
    const result = treeArray
        .map((node) => {
        // Nếu có children, gọi hàm đệ quy để xử lý node con
        if (node.children) {
            node.children = deleteItemsByIds(node.children, idsToDelete);
        }
        return node;
    })
        .filter((node) => !idsToDelete.includes(String(node?.id))); // Lọc bỏ node có id trùng với idToDelete
    return result;
};
// Hàm đệ quy để xóa tất cả các id trong mảng
export function removeIdsFromTree(details) {
    return details.map((detail) => {
        const { id: _id, parentId: _parentId, children, ...rest } = detail;
        const updatedChildren = children ? removeIdsFromTree(children) : undefined;
        return {
            ...rest,
            children: updatedChildren
        };
    });
}
export const getChildKeys = (record) => {
    let keys = [];
    if (record.children) {
        record.children.forEach((child) => {
            keys.push(String(child.id));
            keys = keys.concat(getChildKeys(child)); // Đệ quy lấy tất cả các con
        });
    }
    return keys;
};
export const getAllKeys = (treeArray) => {
    const result = [];
    const stack = [...treeArray];
    while (stack.length > 0) {
        const node = stack.pop();
        result.push(String(node.id));
        if (node.children) {
            stack.push(...node.children); // Đẩy children vào stack
        }
    }
    return result;
};
export const searchFromTree = (sources, searchParams) => {
    if (searchParams?.every((param) => param.searchInput === undefined)) {
        return sources;
    }
    // Tạo mảng chứa các kết quả tìm kiếm
    const results = [];
    // Hàm để truy xuất giá trị theo đường dẫn key có phân cấp (ví dụ "model.code")
    const getValueByKeyPath = (obj, keyPath) => {
        return keyPath.split('.').reduce((acc, key) => acc?.[key], obj);
    };
    // Hàm đệ quy để tìm kiếm trong item và các children
    const searchRecursive = (source) => {
        // Kiểm tra tất cả các tham số tìm kiếm trong searchParams
        const isMatch = searchParams.some(({ searchInput, keys }) => {
            if (searchInput === undefined)
                return false; // Bỏ qua những searchInput undefined
            const lowerSearchInput = searchInput.trim().toLowerCase(); // Đảm bảo tìm kiếm không phân biệt chữ hoa/thường
            return keys.some((keyPath) => {
                const value = getValueByKeyPath(source, keyPath);
                return value && value.toString().toLowerCase().includes(lowerSearchInput); // So sánh giá trị
            });
        });
        // Nếu phần tử khớp, trả về đối tượng này mà không cần kiểm tra children nữa
        if (isMatch) {
            results.push({ ...source });
            return;
        }
        // Nếu không khớp, tiếp tục kiểm tra các children
        if (source.children && source.children.length > 0) {
            source.children.forEach(searchRecursive); // Đệ quy với các children
        }
        // Trả về null nếu không tìm thấy gì
        return null;
    };
    // Duyệt qua tất cả các phần tử trong sources và kiểm tra tìm kiếm
    sources.forEach((item) => searchRecursive(item));
    // Nếu không có kết quả tìm kiếm, trả về mảng ban đầu
    return results.length === 0 ? sources : results;
};
export function updateObjectInTreeArray(newData, dataArray) {
    const updateRecursively = (items) => {
        return items.map((item) => {
            // Nếu đây là node cha
            if (!!newData?.parentId && item?.id === newData?.parentId) {
                const childIndex = item.children?.findIndex((child) => child.id === newData.id) ?? -1;
                if (childIndex !== -1) {
                    // Cập nhật node con đã tồn tại
                    const updatedChildren = [...(item.children || [])];
                    updatedChildren[childIndex] = { ...updatedChildren[childIndex], ...newData };
                    return { ...item, children: updatedChildren };
                }
                else {
                    // Thêm node con mới
                    return { ...item, children: [...(item.children || []), newData] };
                }
            }
            // Cập nhật thông thường cho node có id khớp
            if (item?.id === newData?.id) {
                return { ...item, ...newData };
            }
            // Kiểm tra đệ quy các node con
            if (item.children) {
                return { ...item, children: updateRecursively(item.children) };
            }
            return item;
        });
    };
    // Kiểm tra xem newData có phải là node cha mới không
    if (!newData.parentId) {
        // Kiểm tra xem node đã tồn tại trong mảng chưa
        const existingIndex = dataArray.findIndex((item) => item.id === newData.id);
        if (existingIndex >= 0) {
            // Cập nhật node cha đã tồn tại
            const updatedArray = [...dataArray];
            updatedArray[existingIndex] = { ...updatedArray[existingIndex], ...newData };
            return updatedArray;
        }
        else {
            // Thêm node cha mới vào mảng
            return [...dataArray, newData];
        }
    }
    return updateRecursively(dataArray);
}
/**
 * Chuyển đổi mảng phẳng thành cấu trúc cây dựa vào parentId
 * @param items Mảng phẳng đầu vào
 * @returns Mảng đã được chuyển thành cấu trúc cây
 */
export function arrayToTree(items) {
    const itemMap = new Map();
    const roots = [];
    // Tạo map các items theo id
    items.forEach((item) => {
        if (item.id !== undefined) {
            itemMap.set(item.id, { ...item, children: undefined });
        }
    });
    // Xây dựng cây
    items.forEach((item) => {
        if (item.id !== undefined) {
            if (item.parentId != null && itemMap.has(item.parentId)) {
                // Nếu có parentId và tồn tại parent, thêm vào children của parent
                const parent = itemMap.get(item.parentId);
                if (!parent.children) {
                    parent.children = [];
                }
                parent.children.push(itemMap.get(item.id));
                // Nếu children rỗng thì set undefined
                if (parent.children.length === 0) {
                    parent.children = undefined;
                }
            }
            else {
                // Nếu không có parentId hoặc không tìm thấy parent, đây là node gốc
                roots.push(itemMap.get(item.id));
            }
        }
    });
    return roots;
}
// tìm kiếm mà lấy thêm những node cha - bỏ những node con
export function filterExactMatchWithParents(treeData, search) {
    const lowerSearch = search.toLowerCase();
    const result = [];
    for (const node of treeData) {
        const title = node.title?.toString().toLowerCase() ?? '';
        if (title === lowerSearch) {
            // Node khớp -> bỏ hết node con từ chỗ tìm trở xuống
            result.push({ ...node, children: [] });
            continue;
        }
        if (node.children?.length) {
            const filteredChildren = filterExactMatchWithParents(node.children, search);
            if (filteredChildren.length > 0) {
                result.push({ ...node, children: filteredChildren });
            }
        }
    }
    return result;
}
